import React from 'react';
import { ChildSupport } from './ChildSupport';
import { Divorce } from './Divorce';

export const ServicesPrices = () => {
  return (
    <div className="services-prices" id="services-prices">
      <div className="services-prices-heading">
        <p>Ціни {'&'} Послуги</p>
      </div>
      <ChildSupport />
      <Divorce />
    </div>
  );
};
